import React from 'react';

export default function SvgAnalyticsIcon(props) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12" fill="currentColor" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1.5 1C1.77614 1 2 1.22386 2 1.5V9.5C2 9.63261 2.05268 9.75978 2.14645 9.85355C2.24021 9.94732 2.36739 10 2.5 10H10.5C10.7761 10 11 10.2239 11 10.5C11 10.7761 10.7761 11 10.5 11H2.5C2.10217 11 1.72064 10.842 1.43934 10.5607C1.15804 10.2794 1 9.89782 1 9.5V1.5C1 1.22386 1.22386 1 1.5 1Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9.14645 4.14645C9.34171 3.95118 9.65829 3.95118 9.85355 4.14645C10.0488 4.34171 10.0488 4.65829 9.85355 4.85355L7.35355 7.35355C7.15829 7.54882 6.84171 7.54882 6.64645 7.35355L5 5.70711L3.85355 6.85355C3.65829 7.04882 3.34171 7.04882 3.14645 6.85355C2.95118 6.65829 2.95118 6.34171 3.14645 6.14645L4.64645 4.64645C4.84171 4.45118 5.15829 4.45118 5.35355 4.64645L7 6.29289L9.14645 4.14645Z"
                fill="currentColor"
            />
        </svg>
    );
}
